import { WORKSPACE_REFLOW_QUERY } from '@core/constants/layout';
import { useMediaQuery } from './useMediaQuery';

export const useWorkspaceReflow = (): boolean => useMediaQuery(WORKSPACE_REFLOW_QUERY);
